import React from 'react';
import requireAuth from '../../hocs/requireAuth';

function DashboardScreen() {
  return <div style={{ height: 300 }}>Dashboard screen</div>;
}

export default requireAuth(DashboardScreen);
